"use strict";
/**
 * Monitor Status Page Handler
 * Wires navigation for the arbitrage monitor status UI.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupMonitorStatusPage = setupMonitorStatusPage;
const navigation_service_1 = require("../services/navigation-service");
const api_1 = require("../api");
const state_1 = require("../state");
const monitor_state_service_1 = require("../services/monitor-state-service");
const monitor_ui_1 = require("../ui/monitor-ui");
const POLL_INTERVAL_MS = 15000;
let poller = null;
let unsubscribe = null;
function setupMonitorStatusPage() {
    const backBtn = document.getElementById("monitor-status-back-btn");
    const statusContainer = document.getElementById("monitor-status-content");
    const orderModeToggle = document.getElementById("monitor-status-order-mode-toggle");
    const orderModeLabel = document.getElementById("monitor-status-order-mode-label");
    if (backBtn) {
        backBtn.addEventListener("click", () => (0, navigation_service_1.navigateToEvents)());
    }
    const render = () => {
        const state = (0, state_1.getState)();
        const summary = state.monitorStatus;
        if (state.currentPage !== "monitor-status") {
            stopPolling();
            return;
        }
        const isReal = summary.orderMode === "real";
        if (orderModeToggle) {
            orderModeToggle.checked = isReal;
        }
        if (orderModeLabel) {
            orderModeLabel.textContent = isReal ? "Real" : "Mock";
            orderModeLabel.classList.toggle("order-mode-real", isReal);
        }
        if (statusContainer) {
            statusContainer.innerHTML = `
				<div class="pair-builder-summary">
					<div>
						<p class="muted">Running</p>
						<div>${summary.running ? "Yes" : "No"}</div>
					</div>
					<div>
						<p class="muted">Pairs</p>
						<div>${summary.pairCount}</div>
					</div>
				</div>
				<div id="monitor-pairs-list"></div>
			`;
        }
        (0, monitor_ui_1.renderMonitorPairs)(summary.pairs, "monitor-pairs-list");
        wireRemoveHandlers();
    };
    const poll = async () => {
        try {
            const [status, pairs] = await Promise.all([
                (0, api_1.getMonitorStatus)(),
                (0, api_1.getMonitorPairs)(),
            ]);
            (0, monitor_state_service_1.setMonitorStatus)({
                running: status.status.running,
                pairCount: status.status.pairCount,
                orderMode: status.status.orderMode ?? "mock",
                pairs: pairs.pairs,
                lastUpdated: Date.now(),
            });
        }
        catch (error) {
            console.error("Failed to refresh monitor status:", error);
        }
    };
    const ensurePolling = () => {
        if (!poller) {
            poller = setInterval(poll, POLL_INTERVAL_MS);
        }
    };
    poll();
    ensurePolling();
    render();
    unsubscribe?.();
    unsubscribe = (0, state_1.subscribe)(render);
    if (orderModeToggle) {
        orderModeToggle.addEventListener("change", async () => {
            const newMode = orderModeToggle.checked ? "real" : "mock";
            try {
                await (0, api_1.setMonitorOrderMode)(newMode);
                (0, monitor_state_service_1.setMonitorStatus)({ orderMode: newMode });
            }
            catch (error) {
                console.error("Failed to set order mode:", error);
                // Revert checkbox to previous state
                orderModeToggle.checked = !orderModeToggle.checked;
            }
        });
    }
}
function stopPolling() {
    if (poller) {
        clearInterval(poller);
        poller = null;
    }
}
function wireRemoveHandlers() {
    const container = document.getElementById("monitor-pairs-list");
    if (!container) {
        return;
    }
    container
        .querySelectorAll("[data-remove-pair]")
        .forEach((btn) => {
        btn.addEventListener("click", async () => {
            const kalshiTicker = btn.dataset.kalshiTicker;
            const pmSlug = btn.dataset.pmSlug;
            if (!kalshiTicker || !pmSlug)
                return;
            try {
                await (0, api_1.removeMonitorPair)({ kalshiTicker, pmSlug });
                const pairs = await (0, api_1.getMonitorPairs)();
                (0, monitor_state_service_1.setMonitorStatus)({
                    pairs: pairs.pairs,
                    pairCount: pairs.count,
                    lastUpdated: Date.now(),
                });
            }
            catch (error) {
                console.error("Failed to remove monitor pair:", error);
            }
        });
    });
}
